export default {
    SCHEDULE_MONTHLY: "SCHEDULE_MONTHLY",
    SCHEDULE_MECADOPAGO: "SCHEDULE_MECADOPAGO"
};